import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import store from "./store/store";
import * as serviceWorker from './serviceWorker';
import App from './App';


import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache} from '@apollo/client';
import {ApolloProvider as ApolloHooksProvider} from '@apollo/react-hooks'

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
        uri: 'https://api.scoutafrique.com/graphql',
        headers: {
            authorization: localStorage.getItem('Authorization'),
        },
    })
});

ReactDOM.render(
    <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
            <Provider store={store}>
                <App/>
            </Provider>
        </ApolloHooksProvider>
    </ApolloProvider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
